var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHybridCareSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7602 3.68666L16.9037 13.6867C16.5971 14.76 15.6161 15.5 14.4999 15.5H3.97695C2.31606 15.5 1.11691 13.9103 1.5731 12.3133L4.42962 2.31334C4.73622 1.24001 5.71722 0.5 6.83347 0.5H17.3564C19.0173 0.5 20.2164 2.08966 19.7602 3.68666Z",
    fill: "white",
    stroke: "#7460C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44655 9.7583H10.1157C11.4632 9.7583 12.3341 8.6583 12.3341 7.31997C12.3341 6.42163 11.7657 5.95413 10.8491 5.95413H10.1891L9.44655 9.7583ZM7.67739 10.6291L8.74989 5.0833C8.81405 4.7533 9.02489 4.57913 9.35489 4.57913H10.9499C12.8474 4.57913 13.9841 5.53247 13.9841 7.1733C13.9841 9.36413 12.4074 11.1333 10.1432 11.1333H8.08072C7.75072 11.1333 7.61322 10.9591 7.67739 10.6291Z",
    fill: "#7460C2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybridCareSmall);
export default __webpack_public_path__ + "static/media/hybrid-care-small.1a833c500ae1ff477e2f3487f40f072a.svg";
export { ForwardRef as ReactComponent };